<div class="container">
  <div class="contentful-details-block">
    @if (contentfulCategory && contentfulCategory.title) {
      <h1 class="text-center mb-5 mt-5">
        {{ contentfulCategory.title }}
      </h1>
    }
    @if (contentfulCategory && contentfulCategory.detailBlocks) {
      <div class="contentful-details-block-image-wrapper row">
        @for (detailBlock of contentfulCategory.detailBlocks; track detailBlock) {
          <div class="contentful-details-block-image-item">
            @if (detailBlock.title) {
              <div class="contentful-details-block__title" [innerHTML]="detailBlock.title"></div>
            }
            <img alt="detailBlock.name" [src]="detailBlock.image.url" />
            <p [innerHTML]="detailBlock.description"></p>
          </div>
        }
      </div>
    }
  </div>
</div>
